import styled from 'styled-components';

import Button from 'components/Buttons/Button';
import { FaRegCheckCircle } from 'react-icons/fa';

export const CardContainer = styled.div`
  border-radius: 16px;
  background-color: ${({ theme }) => theme.hotelDetails.background};
  box-shadow: 0 2px 16px 0 ${({ theme }) => theme.hotelDetails.boxShadow};
`;

export const Content = styled.div`
  padding: 16px;
`;

export const ContentRefundableItems = styled.div`
  display: flex;
  margin: 4px 0;
`;

export const NightsAndNumberOfHost = styled.span`
  font-size: 14px;
  line-height: 1.43;
  color: ${({ theme }) => theme.hotelDetails.minorGrey};
`;

export const ValuesContainer = styled.div`
  margin-top: 16px;
`;

export const Tag = styled.div`
  margin-top: 16px;
`;

export const SeeRoomsButton = styled(Button)`
  height: 56px;
  margin-top: 24px;
`;

export const Separator = styled.div`
  width: 100%;
  margin: 8px 0px;
  border-bottom: solid 1px ${({ theme }) => theme.hotelDetails.separator};
`;

export const TextFare = styled.span`
  font-size: 14px;
  letter-spacing: -0.2px;
  color: ${({ theme }) => theme.hotelDetails.strongGrey};
`;

export const Description = styled.li`
  font-size: 14px;
  margin-top: 10px;
  list-style-type: disc;
  color: ${({ theme }) => theme.hotelDetails.strongGrey};
`;
export const PayAtDestination = styled.div`
  height: 20%;
  display: flex;
  align-items: center;
`;

export const PayAtDestinationText = styled.div`
  font-size: 14px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  width: 200px;
  color: ${({ theme }) => theme.dataCardHotels.cleanColor};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-right: 8px;
`;

export const CheckCircleIcon = styled(FaRegCheckCircle)`
  font-size: 14px;
  color: ${({ theme }) => theme.dataCardHotels.cleanColor} !important;
  margin-top: 4px;
  margin-right: 4px;
  @media (min-width: 446px) {
    align-self: center;
    margin-top: 0;
  }
`;